import React from 'react';
import clsx from "clsx";
import { TitleImage, ZoomImage } from "../AboutPageGeneralComp"

/**
 * This component renders the first section of the main markdown that is rendered 
 * in aboutPage page.
 */
const MarkdownBodySection1 = ({refArray, scrollTop}) => (
    <>
        <WhatIsWabliSection myRef={refArray[0]} scrollTop={scrollTop} />
        <LoginWabliSection myRef={refArray[1]}/>
        <CreateNewProjectSection myRef={refArray[2]}/>
    </>
)

//  This component renders what is wabli section.
const WhatIsWabliSection = ({myRef}) => (
    <section  ref={myRef} id="Group1" className={clsx("group")}>
        <h3 id="Group1">What is WABLI?</h3><br />
        <p>WABLI is cloud-based low-code platform that facilitates rapid prototyping for bootstrapping the design process and generating ready-to-deploy web applications.</p> 
        <p>WABLI provides tools for designing, building and deploying your web applications.</p>
        <p>Designing a web application using WABLI.</p>
        <p>Below you can find some examples on how to design, build and deploy your web applications.</p>
    </section>
)

//  This component renders login wabli section.
const LoginWabliSection = ({myRef}) => (
    <section ref={myRef} id="Group5" className={clsx("group")} style={{marginTop: '1rem'}}>
        <h3 id="Group2">Login to WABLI</h3><br />
        <p id='titleId'>You can login to WABLI using your GitHub account by visiting the following url: <a  href="https://wabli.netlify.app" target="_blank" rel="noreferrer">https://wabli.netlify.app</a>.</p>
        <ZoomImage srcImg='/images/AboutPageMarkdownImg/1.jpg' />
        <br />
        <br />
    </section>
)

//  This component renders create new project section.
const CreateNewProjectSection = ({myRef}) => (
    <section ref={myRef} id="Group6" className={clsx("group")}>
        <h3 id="Group3">Create new project</h3><br />
        <TitleImage
            title='You can create a new project through the landing page by clicking on the "Create new project" button.'
            srcImg='/images/AboutPageMarkdownImg/2.jpg'
        />
        <TitleImage
            title='You can then complete the details of your project (App name, Description etc.).'
            srcImg='/images/AboutPageMarkdownImg/3.jpg'
        />
        <TitleImage
            title='Click "Next".'
            srcImg='/images/AboutPageMarkdownImg/3a.jpg'
        />
        <TitleImage 
            title='Click "Finish".'
            srcImg='/images/AboutPageMarkdownImg/3b.jpg'
        />
        <TitleImage
            title='Click "Save".'
            srcImg='/images/AboutPageMarkdownImg/3b.jpg'
        />
        <br />
    </section>
)

export default MarkdownBodySection1;